export const DollarSign = () => (
  <div data-testid={dollarDivTestId} className="flex items-center pl-2 pr-1">
    <span>$</span>
  </div>
);

export const dollarDivTestId = "dollar-div";
